/**
 * Generated by orval 🍺
 * Do not edit manually.
 * BaseHit Api
 * An API for accessing data for BaseHit.com
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ErrorResult,
  GetLeagueIdAchievementListParams,
  GetLeagueIdAllTimeLeadersParams,
  GetLeagueIdAwardsParams,
  GetLeagueIdDraftLotteryParams,
  GetLeagueIdDraftParams,
  GetLeagueIdPlayersParams,
  GetLeagueIdPlayoffsParams,
  GetLeagueIdSeasonLeadersParams,
  GetLeagueIdStandingsParams,
  GetLeagueIdStatsParams,
  GetLeagueIdTeamStatsParams,
  GetLeagueIdTradesParams,
  GetLeagueIdTransactionsParams,
  GetLeagueIdViewParams,
  League,
  LeagueAchievementListResponse,
  LeagueAchievementsResponse,
  LeagueAllTimeLeadersResponse,
  LeagueAwardsResponse,
  LeagueCommishToolsResponse,
  LeagueDraftLotteryResponse,
  LeagueDraftOrderResponse,
  LeagueDraftResponse,
  LeagueFeaturesResponse,
  LeagueFinancialsRow,
  LeagueFreeAgentBid,
  LeagueHallOfFameResponse,
  LeagueLowMinorsCheckResponse,
  LeaguePlayersResponse,
  LeaguePlayoffsResponse,
  LeagueScoreboardResponse,
  LeagueSeasonLeadersResponse,
  LeagueSeasonRow,
  LeagueSettingsResponse,
  LeagueStadiumRow,
  LeagueStandingsResponse,
  LeagueStatsResponse,
  LeagueStructureResponse,
  LeagueTeamOwnersResponse,
  LeagueTeamStatsResponse,
  LeagueTradeDetailResponse,
  LeagueTradesResponse,
  LeagueTransactionsResponse,
  LeagueViewResponse,
  Player,
  ProblemDetails,
  Team,
  UpdateDraftOrderRequest,
  UpdateLeagueSettingsRequest,
  UpdateLeagueStructureRequest,
  UpdateTeamOwnerRequest
} from '../models';

import { fetcher } from '../../fetcher';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary League achievements summary (per-type top-10 with tie-collapse data). Requires auth. 404 if league missing.
 */
export const getLeagueIdAchievements = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<LeagueAchievementsResponse>(
      {url: `/League/${id}/Achievements`, method: 'GET', signal
    },
      );
    }




export const getGetLeagueIdAchievementsQueryKey = (id: number,) => {
    return [
    `/League/${id}/Achievements`
    ] as const;
    }


export const getGetLeagueIdAchievementsQueryOptions = <TData = Awaited<ReturnType<typeof getLeagueIdAchievements>>, TError = ProblemDetails>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdAchievements>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeagueIdAchievementsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeagueIdAchievements>>> = ({ signal }) => getLeagueIdAchievements(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdAchievements>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLeagueIdAchievementsQueryResult = NonNullable<Awaited<ReturnType<typeof getLeagueIdAchievements>>>
export type GetLeagueIdAchievementsQueryError = ProblemDetails


export function useGetLeagueIdAchievements<TData = Awaited<ReturnType<typeof getLeagueIdAchievements>>, TError = ProblemDetails>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdAchievements>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdAchievements>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdAchievements>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdAchievements<TData = Awaited<ReturnType<typeof getLeagueIdAchievements>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdAchievements>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdAchievements>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdAchievements>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdAchievements<TData = Awaited<ReturnType<typeof getLeagueIdAchievements>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdAchievements>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary League achievements summary (per-type top-10 with tie-collapse data). Requires auth. 404 if league missing.
 */

export function useGetLeagueIdAchievements<TData = Awaited<ReturnType<typeof getLeagueIdAchievements>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdAchievements>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLeagueIdAchievementsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Drill-down list of every achievement instance for one type within a league. Requires auth. 400 if achievementTypeId missing/zero; 404 if league missing or no rows for type.
 */
export const getLeagueIdAchievementList = (
    id: number,
    params: GetLeagueIdAchievementListParams,
 signal?: AbortSignal
) => {


      return fetcher<LeagueAchievementListResponse>(
      {url: `/League/${id}/AchievementList`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetLeagueIdAchievementListQueryKey = (id: number,
    params?: GetLeagueIdAchievementListParams,) => {
    return [
    `/League/${id}/AchievementList`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLeagueIdAchievementListQueryOptions = <TData = Awaited<ReturnType<typeof getLeagueIdAchievementList>>, TError = ErrorResult | ProblemDetails>(id: number,
    params: GetLeagueIdAchievementListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdAchievementList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeagueIdAchievementListQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeagueIdAchievementList>>> = ({ signal }) => getLeagueIdAchievementList(id,params, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdAchievementList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLeagueIdAchievementListQueryResult = NonNullable<Awaited<ReturnType<typeof getLeagueIdAchievementList>>>
export type GetLeagueIdAchievementListQueryError = ErrorResult | ProblemDetails


export function useGetLeagueIdAchievementList<TData = Awaited<ReturnType<typeof getLeagueIdAchievementList>>, TError = ErrorResult | ProblemDetails>(
 id: number,
    params: GetLeagueIdAchievementListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdAchievementList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdAchievementList>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdAchievementList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdAchievementList<TData = Awaited<ReturnType<typeof getLeagueIdAchievementList>>, TError = ErrorResult | ProblemDetails>(
 id: number,
    params: GetLeagueIdAchievementListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdAchievementList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdAchievementList>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdAchievementList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdAchievementList<TData = Awaited<ReturnType<typeof getLeagueIdAchievementList>>, TError = ErrorResult | ProblemDetails>(
 id: number,
    params: GetLeagueIdAchievementListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdAchievementList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Drill-down list of every achievement instance for one type within a league. Requires auth. 400 if achievementTypeId missing/zero; 404 if league missing or no rows for type.
 */

export function useGetLeagueIdAchievementList<TData = Awaited<ReturnType<typeof getLeagueIdAchievementList>>, TError = ErrorResult | ProblemDetails>(
 id: number,
    params: GetLeagueIdAchievementListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdAchievementList>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLeagueIdAchievementListQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary All-time statistical leaders. show ∈ {career, season, careerbatting, careerpitching, seasonbatting, seasonpitching} (default career when omitted). 400 if show is non-empty and not in the set; 404 if league missing, exhibition, or has no regular season.
 */
export const getLeagueIdAllTimeLeaders = (
    id: number,
    params?: GetLeagueIdAllTimeLeadersParams,
 signal?: AbortSignal
) => {


      return fetcher<LeagueAllTimeLeadersResponse>(
      {url: `/League/${id}/AllTimeLeaders`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetLeagueIdAllTimeLeadersQueryKey = (id: number,
    params?: GetLeagueIdAllTimeLeadersParams,) => {
    return [
    `/League/${id}/AllTimeLeaders`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLeagueIdAllTimeLeadersQueryOptions = <TData = Awaited<ReturnType<typeof getLeagueIdAllTimeLeaders>>, TError = ProblemDetails>(id: number,
    params?: GetLeagueIdAllTimeLeadersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdAllTimeLeaders>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeagueIdAllTimeLeadersQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeagueIdAllTimeLeaders>>> = ({ signal }) => getLeagueIdAllTimeLeaders(id,params, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdAllTimeLeaders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLeagueIdAllTimeLeadersQueryResult = NonNullable<Awaited<ReturnType<typeof getLeagueIdAllTimeLeaders>>>
export type GetLeagueIdAllTimeLeadersQueryError = ProblemDetails


export function useGetLeagueIdAllTimeLeaders<TData = Awaited<ReturnType<typeof getLeagueIdAllTimeLeaders>>, TError = ProblemDetails>(
 id: number,
    params: undefined |  GetLeagueIdAllTimeLeadersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdAllTimeLeaders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdAllTimeLeaders>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdAllTimeLeaders>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdAllTimeLeaders<TData = Awaited<ReturnType<typeof getLeagueIdAllTimeLeaders>>, TError = ProblemDetails>(
 id: number,
    params?: GetLeagueIdAllTimeLeadersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdAllTimeLeaders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdAllTimeLeaders>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdAllTimeLeaders>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdAllTimeLeaders<TData = Awaited<ReturnType<typeof getLeagueIdAllTimeLeaders>>, TError = ProblemDetails>(
 id: number,
    params?: GetLeagueIdAllTimeLeadersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdAllTimeLeaders>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary All-time statistical leaders. show ∈ {career, season, careerbatting, careerpitching, seasonbatting, seasonpitching} (default career when omitted). 400 if show is non-empty and not in the set; 404 if league missing, exhibition, or has no regular season.
 */

export function useGetLeagueIdAllTimeLeaders<TData = Awaited<ReturnType<typeof getLeagueIdAllTimeLeaders>>, TError = ProblemDetails>(
 id: number,
    params?: GetLeagueIdAllTimeLeadersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdAllTimeLeaders>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLeagueIdAllTimeLeadersQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Season awards: actual winners + projected winners. 404 if the league has no awards.
 */
export const getLeagueIdAwards = (
    id: number,
    params?: GetLeagueIdAwardsParams,
 signal?: AbortSignal
) => {


      return fetcher<LeagueAwardsResponse>(
      {url: `/League/${id}/Awards`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetLeagueIdAwardsQueryKey = (id: number,
    params?: GetLeagueIdAwardsParams,) => {
    return [
    `/League/${id}/Awards`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLeagueIdAwardsQueryOptions = <TData = Awaited<ReturnType<typeof getLeagueIdAwards>>, TError = ProblemDetails>(id: number,
    params?: GetLeagueIdAwardsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdAwards>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeagueIdAwardsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeagueIdAwards>>> = ({ signal }) => getLeagueIdAwards(id,params, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdAwards>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLeagueIdAwardsQueryResult = NonNullable<Awaited<ReturnType<typeof getLeagueIdAwards>>>
export type GetLeagueIdAwardsQueryError = ProblemDetails


export function useGetLeagueIdAwards<TData = Awaited<ReturnType<typeof getLeagueIdAwards>>, TError = ProblemDetails>(
 id: number,
    params: undefined |  GetLeagueIdAwardsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdAwards>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdAwards>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdAwards>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdAwards<TData = Awaited<ReturnType<typeof getLeagueIdAwards>>, TError = ProblemDetails>(
 id: number,
    params?: GetLeagueIdAwardsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdAwards>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdAwards>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdAwards>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdAwards<TData = Awaited<ReturnType<typeof getLeagueIdAwards>>, TError = ProblemDetails>(
 id: number,
    params?: GetLeagueIdAwardsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdAwards>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Season awards: actual winners + projected winners. 404 if the league has no awards.
 */

export function useGetLeagueIdAwards<TData = Awaited<ReturnType<typeof getLeagueIdAwards>>, TError = ProblemDetails>(
 id: number,
    params?: GetLeagueIdAwardsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdAwards>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLeagueIdAwardsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Commissioner-tools hub data for a league. Commissioner/admin only.
404 if the league is missing or has no settings; 403 if the caller is
not a commissioner or admin (parity with legacy commishtools.asp).
 */
export const getLeagueIdCommishTools = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<LeagueCommishToolsResponse>(
      {url: `/League/${id}/CommishTools`, method: 'GET', signal
    },
      );
    }




export const getGetLeagueIdCommishToolsQueryKey = (id: number,) => {
    return [
    `/League/${id}/CommishTools`
    ] as const;
    }


export const getGetLeagueIdCommishToolsQueryOptions = <TData = Awaited<ReturnType<typeof getLeagueIdCommishTools>>, TError = ProblemDetails>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdCommishTools>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeagueIdCommishToolsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeagueIdCommishTools>>> = ({ signal }) => getLeagueIdCommishTools(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdCommishTools>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLeagueIdCommishToolsQueryResult = NonNullable<Awaited<ReturnType<typeof getLeagueIdCommishTools>>>
export type GetLeagueIdCommishToolsQueryError = ProblemDetails


export function useGetLeagueIdCommishTools<TData = Awaited<ReturnType<typeof getLeagueIdCommishTools>>, TError = ProblemDetails>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdCommishTools>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdCommishTools>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdCommishTools>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdCommishTools<TData = Awaited<ReturnType<typeof getLeagueIdCommishTools>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdCommishTools>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdCommishTools>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdCommishTools>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdCommishTools<TData = Awaited<ReturnType<typeof getLeagueIdCommishTools>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdCommishTools>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Commissioner-tools hub data for a league. Commissioner/admin only.
404 if the league is missing or has no settings; 403 if the caller is
not a commissioner or admin (parity with legacy commishtools.asp).
 */

export function useGetLeagueIdCommishTools<TData = Awaited<ReturnType<typeof getLeagueIdCommishTools>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdCommishTools>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLeagueIdCommishToolsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Flat league-identity read for the shared league nav + league/team pages.
Returns the base League entity (user-aware).
 */
export const getLeagueId = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<League>(
      {url: `/League/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetLeagueIdQueryKey = (id: number,) => {
    return [
    `/League/${id}`
    ] as const;
    }


export const getGetLeagueIdQueryOptions = <TData = Awaited<ReturnType<typeof getLeagueId>>, TError = ProblemDetails>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeagueIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeagueId>>> = ({ signal }) => getLeagueId(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLeagueId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLeagueIdQueryResult = NonNullable<Awaited<ReturnType<typeof getLeagueId>>>
export type GetLeagueIdQueryError = ProblemDetails


export function useGetLeagueId<TData = Awaited<ReturnType<typeof getLeagueId>>, TError = ProblemDetails>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueId>>,
          TError,
          Awaited<ReturnType<typeof getLeagueId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueId<TData = Awaited<ReturnType<typeof getLeagueId>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueId>>,
          TError,
          Awaited<ReturnType<typeof getLeagueId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueId<TData = Awaited<ReturnType<typeof getLeagueId>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Flat league-identity read for the shared league nav + league/team pages.
Returns the base League entity (user-aware).
 */

export function useGetLeagueId<TData = Awaited<ReturnType<typeof getLeagueId>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLeagueIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Gets all teams in a league
 */
export const getLeagueIdTeams = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<Team[]>(
      {url: `/League/${id}/teams`, method: 'GET', signal
    },
      );
    }




export const getGetLeagueIdTeamsQueryKey = (id: number,) => {
    return [
    `/League/${id}/teams`
    ] as const;
    }


export const getGetLeagueIdTeamsQueryOptions = <TData = Awaited<ReturnType<typeof getLeagueIdTeams>>, TError = unknown>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdTeams>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeagueIdTeamsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeagueIdTeams>>> = ({ signal }) => getLeagueIdTeams(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdTeams>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLeagueIdTeamsQueryResult = NonNullable<Awaited<ReturnType<typeof getLeagueIdTeams>>>
export type GetLeagueIdTeamsQueryError = unknown


export function useGetLeagueIdTeams<TData = Awaited<ReturnType<typeof getLeagueIdTeams>>, TError = unknown>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdTeams>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdTeams>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdTeams>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdTeams<TData = Awaited<ReturnType<typeof getLeagueIdTeams>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdTeams>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdTeams>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdTeams>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdTeams<TData = Awaited<ReturnType<typeof getLeagueIdTeams>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdTeams>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets all teams in a league
 */

export function useGetLeagueIdTeams<TData = Awaited<ReturnType<typeof getLeagueIdTeams>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdTeams>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLeagueIdTeamsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Gets all free agents available in a league
 */
export const getLeagueIdFreeagents = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<Player[]>(
      {url: `/League/${id}/freeagents`, method: 'GET', signal
    },
      );
    }




export const getGetLeagueIdFreeagentsQueryKey = (id: number,) => {
    return [
    `/League/${id}/freeagents`
    ] as const;
    }


export const getGetLeagueIdFreeagentsQueryOptions = <TData = Awaited<ReturnType<typeof getLeagueIdFreeagents>>, TError = unknown>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdFreeagents>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeagueIdFreeagentsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeagueIdFreeagents>>> = ({ signal }) => getLeagueIdFreeagents(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdFreeagents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLeagueIdFreeagentsQueryResult = NonNullable<Awaited<ReturnType<typeof getLeagueIdFreeagents>>>
export type GetLeagueIdFreeagentsQueryError = unknown


export function useGetLeagueIdFreeagents<TData = Awaited<ReturnType<typeof getLeagueIdFreeagents>>, TError = unknown>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdFreeagents>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdFreeagents>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdFreeagents>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdFreeagents<TData = Awaited<ReturnType<typeof getLeagueIdFreeagents>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdFreeagents>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdFreeagents>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdFreeagents>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdFreeagents<TData = Awaited<ReturnType<typeof getLeagueIdFreeagents>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdFreeagents>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets all free agents available in a league
 */

export function useGetLeagueIdFreeagents<TData = Awaited<ReturnType<typeof getLeagueIdFreeagents>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdFreeagents>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLeagueIdFreeagentsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Gets all free agent bids for a league
 */
export const getLeagueIdFreeagentbids = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<LeagueFreeAgentBid[]>(
      {url: `/League/${id}/freeagentbids`, method: 'GET', signal
    },
      );
    }




export const getGetLeagueIdFreeagentbidsQueryKey = (id: number,) => {
    return [
    `/League/${id}/freeagentbids`
    ] as const;
    }


export const getGetLeagueIdFreeagentbidsQueryOptions = <TData = Awaited<ReturnType<typeof getLeagueIdFreeagentbids>>, TError = unknown>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdFreeagentbids>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeagueIdFreeagentbidsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeagueIdFreeagentbids>>> = ({ signal }) => getLeagueIdFreeagentbids(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdFreeagentbids>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLeagueIdFreeagentbidsQueryResult = NonNullable<Awaited<ReturnType<typeof getLeagueIdFreeagentbids>>>
export type GetLeagueIdFreeagentbidsQueryError = unknown


export function useGetLeagueIdFreeagentbids<TData = Awaited<ReturnType<typeof getLeagueIdFreeagentbids>>, TError = unknown>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdFreeagentbids>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdFreeagentbids>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdFreeagentbids>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdFreeagentbids<TData = Awaited<ReturnType<typeof getLeagueIdFreeagentbids>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdFreeagentbids>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdFreeagentbids>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdFreeagentbids>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdFreeagentbids<TData = Awaited<ReturnType<typeof getLeagueIdFreeagentbids>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdFreeagentbids>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets all free agent bids for a league
 */

export function useGetLeagueIdFreeagentbids<TData = Awaited<ReturnType<typeof getLeagueIdFreeagentbids>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdFreeagentbids>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLeagueIdFreeagentbidsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Draft picks for a league's season. Requires auth. 404 if league missing,
HasDraft=false, or season out of range (parity with legacy draft.asp).
Empty Rows is a valid 200 (React renders "draft has not yet taken place"
or "league has not started" alert).
 */
export const getLeagueIdDraft = (
    id: number,
    params?: GetLeagueIdDraftParams,
 signal?: AbortSignal
) => {


      return fetcher<LeagueDraftResponse>(
      {url: `/League/${id}/Draft`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetLeagueIdDraftQueryKey = (id: number,
    params?: GetLeagueIdDraftParams,) => {
    return [
    `/League/${id}/Draft`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLeagueIdDraftQueryOptions = <TData = Awaited<ReturnType<typeof getLeagueIdDraft>>, TError = ProblemDetails>(id: number,
    params?: GetLeagueIdDraftParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdDraft>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeagueIdDraftQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeagueIdDraft>>> = ({ signal }) => getLeagueIdDraft(id,params, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdDraft>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLeagueIdDraftQueryResult = NonNullable<Awaited<ReturnType<typeof getLeagueIdDraft>>>
export type GetLeagueIdDraftQueryError = ProblemDetails


export function useGetLeagueIdDraft<TData = Awaited<ReturnType<typeof getLeagueIdDraft>>, TError = ProblemDetails>(
 id: number,
    params: undefined |  GetLeagueIdDraftParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdDraft>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdDraft>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdDraft>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdDraft<TData = Awaited<ReturnType<typeof getLeagueIdDraft>>, TError = ProblemDetails>(
 id: number,
    params?: GetLeagueIdDraftParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdDraft>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdDraft>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdDraft>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdDraft<TData = Awaited<ReturnType<typeof getLeagueIdDraft>>, TError = ProblemDetails>(
 id: number,
    params?: GetLeagueIdDraftParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdDraft>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Draft picks for a league's season. Requires auth. 404 if league missing,
HasDraft=false, or season out of range (parity with legacy draft.asp).
Empty Rows is a valid 200 (React renders "draft has not yet taken place"
or "league has not started" alert).
 */

export function useGetLeagueIdDraft<TData = Awaited<ReturnType<typeof getLeagueIdDraft>>, TError = ProblemDetails>(
 id: number,
    params?: GetLeagueIdDraftParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdDraft>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLeagueIdDraftQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Draft lottery results for a league's season. Requires auth. 404 if league
missing, HasDraft=false, or season out of range. Empty Rows is a valid
200 — React redirects to /league/{id}/draft client-side (parity with
legacy 302).
 */
export const getLeagueIdDraftLottery = (
    id: number,
    params?: GetLeagueIdDraftLotteryParams,
 signal?: AbortSignal
) => {


      return fetcher<LeagueDraftLotteryResponse>(
      {url: `/League/${id}/DraftLottery`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetLeagueIdDraftLotteryQueryKey = (id: number,
    params?: GetLeagueIdDraftLotteryParams,) => {
    return [
    `/League/${id}/DraftLottery`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLeagueIdDraftLotteryQueryOptions = <TData = Awaited<ReturnType<typeof getLeagueIdDraftLottery>>, TError = ProblemDetails>(id: number,
    params?: GetLeagueIdDraftLotteryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdDraftLottery>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeagueIdDraftLotteryQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeagueIdDraftLottery>>> = ({ signal }) => getLeagueIdDraftLottery(id,params, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdDraftLottery>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLeagueIdDraftLotteryQueryResult = NonNullable<Awaited<ReturnType<typeof getLeagueIdDraftLottery>>>
export type GetLeagueIdDraftLotteryQueryError = ProblemDetails


export function useGetLeagueIdDraftLottery<TData = Awaited<ReturnType<typeof getLeagueIdDraftLottery>>, TError = ProblemDetails>(
 id: number,
    params: undefined |  GetLeagueIdDraftLotteryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdDraftLottery>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdDraftLottery>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdDraftLottery>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdDraftLottery<TData = Awaited<ReturnType<typeof getLeagueIdDraftLottery>>, TError = ProblemDetails>(
 id: number,
    params?: GetLeagueIdDraftLotteryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdDraftLottery>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdDraftLottery>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdDraftLottery>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdDraftLottery<TData = Awaited<ReturnType<typeof getLeagueIdDraftLottery>>, TError = ProblemDetails>(
 id: number,
    params?: GetLeagueIdDraftLotteryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdDraftLottery>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Draft lottery results for a league's season. Requires auth. 404 if league
missing, HasDraft=false, or season out of range. Empty Rows is a valid
200 — React redirects to /league/{id}/draft client-side (parity with
legacy 302).
 */

export function useGetLeagueIdDraftLottery<TData = Awaited<ReturnType<typeof getLeagueIdDraftLottery>>, TError = ProblemDetails>(
 id: number,
    params?: GetLeagueIdDraftLotteryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdDraftLottery>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLeagueIdDraftLotteryQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary The current draft pick order grouped into rounds, plus the league team
list for the reorder dropdowns. Commissioner/admin only. 404 if the
league is missing; 403 if the caller is not a manager.
 */
export const getLeagueIdDraftOrder = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<LeagueDraftOrderResponse>(
      {url: `/League/${id}/DraftOrder`, method: 'GET', signal
    },
      );
    }




export const getGetLeagueIdDraftOrderQueryKey = (id: number,) => {
    return [
    `/League/${id}/DraftOrder`
    ] as const;
    }


export const getGetLeagueIdDraftOrderQueryOptions = <TData = Awaited<ReturnType<typeof getLeagueIdDraftOrder>>, TError = ProblemDetails>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdDraftOrder>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeagueIdDraftOrderQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeagueIdDraftOrder>>> = ({ signal }) => getLeagueIdDraftOrder(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdDraftOrder>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLeagueIdDraftOrderQueryResult = NonNullable<Awaited<ReturnType<typeof getLeagueIdDraftOrder>>>
export type GetLeagueIdDraftOrderQueryError = ProblemDetails


export function useGetLeagueIdDraftOrder<TData = Awaited<ReturnType<typeof getLeagueIdDraftOrder>>, TError = ProblemDetails>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdDraftOrder>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdDraftOrder>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdDraftOrder>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdDraftOrder<TData = Awaited<ReturnType<typeof getLeagueIdDraftOrder>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdDraftOrder>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdDraftOrder>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdDraftOrder>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdDraftOrder<TData = Awaited<ReturnType<typeof getLeagueIdDraftOrder>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdDraftOrder>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The current draft pick order grouped into rounds, plus the league team
list for the reorder dropdowns. Commissioner/admin only. 404 if the
league is missing; 403 if the caller is not a manager.
 */

export function useGetLeagueIdDraftOrder<TData = Awaited<ReturnType<typeof getLeagueIdDraftOrder>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdDraftOrder>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLeagueIdDraftOrderQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Applies the reordered draft pick assignments (commissioner/admin only).
400 if a submitted team is not part of the league or if a draft pick
has already been made and cannot be reordered.
 */
export const putLeagueIdDraftOrder = (
    id: number,
    updateDraftOrderRequest?: UpdateDraftOrderRequest,
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/League/${id}/DraftOrder`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateDraftOrderRequest, signal
    },
      );
    }




export const getPutLeagueIdDraftOrderMutationKey = () => ['putLeagueIdDraftOrder'] as const;

export const getPutLeagueIdDraftOrderMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putLeagueIdDraftOrder>>, TError,PutLeagueIdDraftOrderMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putLeagueIdDraftOrder>>, TError,PutLeagueIdDraftOrderMutationVariables, TContext> => {

const mutationKey = getPutLeagueIdDraftOrderMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putLeagueIdDraftOrder>>, PutLeagueIdDraftOrderMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  putLeagueIdDraftOrder(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutLeagueIdDraftOrderMutationResult = NonNullable<Awaited<ReturnType<typeof putLeagueIdDraftOrder>>>
    export type PutLeagueIdDraftOrderMutationBody = UpdateDraftOrderRequest | undefined
    export type PutLeagueIdDraftOrderMutationError = ErrorResult | ProblemDetails
    export type PutLeagueIdDraftOrderMutationVariables = {id: number;data?: UpdateDraftOrderRequest}

    /**
 * @summary Applies the reordered draft pick assignments (commissioner/admin only).
400 if a submitted team is not part of the league or if a draft pick
has already been made and cannot be reordered.
 */
export const usePutLeagueIdDraftOrder = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putLeagueIdDraftOrder>>, TError,PutLeagueIdDraftOrderMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putLeagueIdDraftOrder>>,
        TError,
        PutLeagueIdDraftOrderMutationVariables,
        TContext
      > => {
      return useMutation(getPutLeagueIdDraftOrderMutationOptions(options), queryClient);
    }
    /**
 * @summary Resolved League-scoped feature flags for the league (booleans only). Used to decide
            whether menu links show. 404 when the league does not exist.
 */
export const getLeagueIdFeatures = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<LeagueFeaturesResponse>(
      {url: `/League/${id}/Features`, method: 'GET', signal
    },
      );
    }




export const getGetLeagueIdFeaturesQueryKey = (id: number,) => {
    return [
    `/League/${id}/Features`
    ] as const;
    }


export const getGetLeagueIdFeaturesQueryOptions = <TData = Awaited<ReturnType<typeof getLeagueIdFeatures>>, TError = ProblemDetails>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdFeatures>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeagueIdFeaturesQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeagueIdFeatures>>> = ({ signal }) => getLeagueIdFeatures(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdFeatures>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLeagueIdFeaturesQueryResult = NonNullable<Awaited<ReturnType<typeof getLeagueIdFeatures>>>
export type GetLeagueIdFeaturesQueryError = ProblemDetails


export function useGetLeagueIdFeatures<TData = Awaited<ReturnType<typeof getLeagueIdFeatures>>, TError = ProblemDetails>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdFeatures>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdFeatures>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdFeatures>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdFeatures<TData = Awaited<ReturnType<typeof getLeagueIdFeatures>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdFeatures>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdFeatures>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdFeatures>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdFeatures<TData = Awaited<ReturnType<typeof getLeagueIdFeatures>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdFeatures>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Resolved League-scoped feature flags for the league (booleans only). Used to decide
            whether menu links show. 404 when the league does not exist.
 */

export function useGetLeagueIdFeatures<TData = Awaited<ReturnType<typeof getLeagueIdFeatures>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdFeatures>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLeagueIdFeaturesQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Team payroll summary (total/active/AAA/low) for every team in a league. 404 if the league has no regular season.
 */
export const getLeagueIdFinancials = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<LeagueFinancialsRow[]>(
      {url: `/League/${id}/Financials`, method: 'GET', signal
    },
      );
    }




export const getGetLeagueIdFinancialsQueryKey = (id: number,) => {
    return [
    `/League/${id}/Financials`
    ] as const;
    }


export const getGetLeagueIdFinancialsQueryOptions = <TData = Awaited<ReturnType<typeof getLeagueIdFinancials>>, TError = ProblemDetails>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdFinancials>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeagueIdFinancialsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeagueIdFinancials>>> = ({ signal }) => getLeagueIdFinancials(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdFinancials>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLeagueIdFinancialsQueryResult = NonNullable<Awaited<ReturnType<typeof getLeagueIdFinancials>>>
export type GetLeagueIdFinancialsQueryError = ProblemDetails


export function useGetLeagueIdFinancials<TData = Awaited<ReturnType<typeof getLeagueIdFinancials>>, TError = ProblemDetails>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdFinancials>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdFinancials>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdFinancials>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdFinancials<TData = Awaited<ReturnType<typeof getLeagueIdFinancials>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdFinancials>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdFinancials>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdFinancials>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdFinancials<TData = Awaited<ReturnType<typeof getLeagueIdFinancials>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdFinancials>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Team payroll summary (total/active/AAA/low) for every team in a league. 404 if the league has no regular season.
 */

export function useGetLeagueIdFinancials<TData = Awaited<ReturnType<typeof getLeagueIdFinancials>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdFinancials>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLeagueIdFinancialsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Hall of Fame inductees for a league. Requires auth. 404 if league missing or HasAwards=false (parity with legacy halloffame.asp).
 */
export const getLeagueIdHallOfFame = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<LeagueHallOfFameResponse>(
      {url: `/League/${id}/HallOfFame`, method: 'GET', signal
    },
      );
    }




export const getGetLeagueIdHallOfFameQueryKey = (id: number,) => {
    return [
    `/League/${id}/HallOfFame`
    ] as const;
    }


export const getGetLeagueIdHallOfFameQueryOptions = <TData = Awaited<ReturnType<typeof getLeagueIdHallOfFame>>, TError = ProblemDetails>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdHallOfFame>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeagueIdHallOfFameQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeagueIdHallOfFame>>> = ({ signal }) => getLeagueIdHallOfFame(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdHallOfFame>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLeagueIdHallOfFameQueryResult = NonNullable<Awaited<ReturnType<typeof getLeagueIdHallOfFame>>>
export type GetLeagueIdHallOfFameQueryError = ProblemDetails


export function useGetLeagueIdHallOfFame<TData = Awaited<ReturnType<typeof getLeagueIdHallOfFame>>, TError = ProblemDetails>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdHallOfFame>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdHallOfFame>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdHallOfFame>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdHallOfFame<TData = Awaited<ReturnType<typeof getLeagueIdHallOfFame>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdHallOfFame>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdHallOfFame>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdHallOfFame>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdHallOfFame<TData = Awaited<ReturnType<typeof getLeagueIdHallOfFame>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdHallOfFame>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Hall of Fame inductees for a league. Requires auth. 404 if league missing or HasAwards=false (parity with legacy halloffame.asp).
 */

export function useGetLeagueIdHallOfFame<TData = Awaited<ReturnType<typeof getLeagueIdHallOfFame>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdHallOfFame>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLeagueIdHallOfFameQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary The per-team low-minors report (draft picks vs AAA/LM roster counts).
Commissioner/admin only. 404 if the league is missing; 403 if the caller
is not a manager.
 */
export const getLeagueIdLowMinorsCheck = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<LeagueLowMinorsCheckResponse>(
      {url: `/League/${id}/LowMinorsCheck`, method: 'GET', signal
    },
      );
    }




export const getGetLeagueIdLowMinorsCheckQueryKey = (id: number,) => {
    return [
    `/League/${id}/LowMinorsCheck`
    ] as const;
    }


export const getGetLeagueIdLowMinorsCheckQueryOptions = <TData = Awaited<ReturnType<typeof getLeagueIdLowMinorsCheck>>, TError = ProblemDetails>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdLowMinorsCheck>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeagueIdLowMinorsCheckQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeagueIdLowMinorsCheck>>> = ({ signal }) => getLeagueIdLowMinorsCheck(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdLowMinorsCheck>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLeagueIdLowMinorsCheckQueryResult = NonNullable<Awaited<ReturnType<typeof getLeagueIdLowMinorsCheck>>>
export type GetLeagueIdLowMinorsCheckQueryError = ProblemDetails


export function useGetLeagueIdLowMinorsCheck<TData = Awaited<ReturnType<typeof getLeagueIdLowMinorsCheck>>, TError = ProblemDetails>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdLowMinorsCheck>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdLowMinorsCheck>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdLowMinorsCheck>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdLowMinorsCheck<TData = Awaited<ReturnType<typeof getLeagueIdLowMinorsCheck>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdLowMinorsCheck>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdLowMinorsCheck>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdLowMinorsCheck>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdLowMinorsCheck<TData = Awaited<ReturnType<typeof getLeagueIdLowMinorsCheck>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdLowMinorsCheck>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The per-team low-minors report (draft picks vs AAA/LM roster counts).
Commissioner/admin only. 404 if the league is missing; 403 if the caller
is not a manager.
 */

export function useGetLeagueIdLowMinorsCheck<TData = Awaited<ReturnType<typeof getLeagueIdLowMinorsCheck>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdLowMinorsCheck>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLeagueIdLowMinorsCheckQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary All rostered + FA players in a league filtered by position. Requires auth.
position required: 0 (all) or 1..9 (specific). 400 if position invalid or
missing; 404 if league missing. (Trade-block input retired in #443.)
 */
export const getLeagueIdPlayers = (
    id: number,
    params: GetLeagueIdPlayersParams,
 signal?: AbortSignal
) => {


      return fetcher<LeaguePlayersResponse>(
      {url: `/League/${id}/Players`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetLeagueIdPlayersQueryKey = (id: number,
    params?: GetLeagueIdPlayersParams,) => {
    return [
    `/League/${id}/Players`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLeagueIdPlayersQueryOptions = <TData = Awaited<ReturnType<typeof getLeagueIdPlayers>>, TError = ProblemDetails>(id: number,
    params: GetLeagueIdPlayersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdPlayers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeagueIdPlayersQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeagueIdPlayers>>> = ({ signal }) => getLeagueIdPlayers(id,params, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdPlayers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLeagueIdPlayersQueryResult = NonNullable<Awaited<ReturnType<typeof getLeagueIdPlayers>>>
export type GetLeagueIdPlayersQueryError = ProblemDetails


export function useGetLeagueIdPlayers<TData = Awaited<ReturnType<typeof getLeagueIdPlayers>>, TError = ProblemDetails>(
 id: number,
    params: GetLeagueIdPlayersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdPlayers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdPlayers>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdPlayers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdPlayers<TData = Awaited<ReturnType<typeof getLeagueIdPlayers>>, TError = ProblemDetails>(
 id: number,
    params: GetLeagueIdPlayersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdPlayers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdPlayers>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdPlayers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdPlayers<TData = Awaited<ReturnType<typeof getLeagueIdPlayers>>, TError = ProblemDetails>(
 id: number,
    params: GetLeagueIdPlayersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdPlayers>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary All rostered + FA players in a league filtered by position. Requires auth.
position required: 0 (all) or 1..9 (specific). 400 if position invalid or
missing; 404 if league missing. (Trade-block input retired in #443.)
 */

export function useGetLeagueIdPlayers<TData = Awaited<ReturnType<typeof getLeagueIdPlayers>>, TError = ProblemDetails>(
 id: number,
    params: GetLeagueIdPlayersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdPlayers>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLeagueIdPlayersQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Playoff bracket + series + games for a league season. Requires auth.
404 if league missing, HidePlayoffsLink=true (large-league guard),
or season out of range. Empty rounds returns 200 with rounds: [].
 */
export const getLeagueIdPlayoffs = (
    id: number,
    params?: GetLeagueIdPlayoffsParams,
 signal?: AbortSignal
) => {


      return fetcher<LeaguePlayoffsResponse>(
      {url: `/League/${id}/Playoffs`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetLeagueIdPlayoffsQueryKey = (id: number,
    params?: GetLeagueIdPlayoffsParams,) => {
    return [
    `/League/${id}/Playoffs`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLeagueIdPlayoffsQueryOptions = <TData = Awaited<ReturnType<typeof getLeagueIdPlayoffs>>, TError = ProblemDetails>(id: number,
    params?: GetLeagueIdPlayoffsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdPlayoffs>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeagueIdPlayoffsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeagueIdPlayoffs>>> = ({ signal }) => getLeagueIdPlayoffs(id,params, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdPlayoffs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLeagueIdPlayoffsQueryResult = NonNullable<Awaited<ReturnType<typeof getLeagueIdPlayoffs>>>
export type GetLeagueIdPlayoffsQueryError = ProblemDetails


export function useGetLeagueIdPlayoffs<TData = Awaited<ReturnType<typeof getLeagueIdPlayoffs>>, TError = ProblemDetails>(
 id: number,
    params: undefined |  GetLeagueIdPlayoffsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdPlayoffs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdPlayoffs>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdPlayoffs>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdPlayoffs<TData = Awaited<ReturnType<typeof getLeagueIdPlayoffs>>, TError = ProblemDetails>(
 id: number,
    params?: GetLeagueIdPlayoffsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdPlayoffs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdPlayoffs>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdPlayoffs>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdPlayoffs<TData = Awaited<ReturnType<typeof getLeagueIdPlayoffs>>, TError = ProblemDetails>(
 id: number,
    params?: GetLeagueIdPlayoffsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdPlayoffs>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Playoff bracket + series + games for a league season. Requires auth.
404 if league missing, HidePlayoffsLink=true (large-league guard),
or season out of range. Empty rounds returns 200 with rounds: [].
 */

export function useGetLeagueIdPlayoffs<TData = Awaited<ReturnType<typeof getLeagueIdPlayoffs>>, TError = ProblemDetails>(
 id: number,
    params?: GetLeagueIdPlayoffsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdPlayoffs>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLeagueIdPlayoffsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Recent and upcoming games for a league's latest season — fixed window of -2..+1 sim days around the current day. Requires auth. 404 if league missing.
 */
export const getLeagueIdScoreboard = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<LeagueScoreboardResponse>(
      {url: `/League/${id}/Scoreboard`, method: 'GET', signal
    },
      );
    }




export const getGetLeagueIdScoreboardQueryKey = (id: number,) => {
    return [
    `/League/${id}/Scoreboard`
    ] as const;
    }


export const getGetLeagueIdScoreboardQueryOptions = <TData = Awaited<ReturnType<typeof getLeagueIdScoreboard>>, TError = ProblemDetails>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdScoreboard>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeagueIdScoreboardQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeagueIdScoreboard>>> = ({ signal }) => getLeagueIdScoreboard(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdScoreboard>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLeagueIdScoreboardQueryResult = NonNullable<Awaited<ReturnType<typeof getLeagueIdScoreboard>>>
export type GetLeagueIdScoreboardQueryError = ProblemDetails


export function useGetLeagueIdScoreboard<TData = Awaited<ReturnType<typeof getLeagueIdScoreboard>>, TError = ProblemDetails>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdScoreboard>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdScoreboard>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdScoreboard>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdScoreboard<TData = Awaited<ReturnType<typeof getLeagueIdScoreboard>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdScoreboard>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdScoreboard>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdScoreboard>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdScoreboard<TData = Awaited<ReturnType<typeof getLeagueIdScoreboard>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdScoreboard>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Recent and upcoming games for a league's latest season — fixed window of -2..+1 sim days around the current day. Requires auth. 404 if league missing.
 */

export function useGetLeagueIdScoreboard<TData = Awaited<ReturnType<typeof getLeagueIdScoreboard>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdScoreboard>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLeagueIdScoreboardQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Season statistical leaders (batting/pitching) for a league. show ("batting"|"pitching") required; season optional (defaults to current). 400 if show missing/invalid; 404 if league missing, exhibition, no regular season, or season out of range.
 */
export const getLeagueIdSeasonLeaders = (
    id: number,
    params: GetLeagueIdSeasonLeadersParams,
 signal?: AbortSignal
) => {


      return fetcher<LeagueSeasonLeadersResponse>(
      {url: `/League/${id}/SeasonLeaders`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetLeagueIdSeasonLeadersQueryKey = (id: number,
    params?: GetLeagueIdSeasonLeadersParams,) => {
    return [
    `/League/${id}/SeasonLeaders`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLeagueIdSeasonLeadersQueryOptions = <TData = Awaited<ReturnType<typeof getLeagueIdSeasonLeaders>>, TError = ProblemDetails>(id: number,
    params: GetLeagueIdSeasonLeadersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdSeasonLeaders>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeagueIdSeasonLeadersQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeagueIdSeasonLeaders>>> = ({ signal }) => getLeagueIdSeasonLeaders(id,params, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdSeasonLeaders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLeagueIdSeasonLeadersQueryResult = NonNullable<Awaited<ReturnType<typeof getLeagueIdSeasonLeaders>>>
export type GetLeagueIdSeasonLeadersQueryError = ProblemDetails


export function useGetLeagueIdSeasonLeaders<TData = Awaited<ReturnType<typeof getLeagueIdSeasonLeaders>>, TError = ProblemDetails>(
 id: number,
    params: GetLeagueIdSeasonLeadersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdSeasonLeaders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdSeasonLeaders>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdSeasonLeaders>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdSeasonLeaders<TData = Awaited<ReturnType<typeof getLeagueIdSeasonLeaders>>, TError = ProblemDetails>(
 id: number,
    params: GetLeagueIdSeasonLeadersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdSeasonLeaders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdSeasonLeaders>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdSeasonLeaders>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdSeasonLeaders<TData = Awaited<ReturnType<typeof getLeagueIdSeasonLeaders>>, TError = ProblemDetails>(
 id: number,
    params: GetLeagueIdSeasonLeadersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdSeasonLeaders>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Season statistical leaders (batting/pitching) for a league. show ("batting"|"pitching") required; season optional (defaults to current). 400 if show missing/invalid; 404 if league missing, exhibition, no regular season, or season out of range.
 */

export function useGetLeagueIdSeasonLeaders<TData = Awaited<ReturnType<typeof getLeagueIdSeasonLeaders>>, TError = ProblemDetails>(
 id: number,
    params: GetLeagueIdSeasonLeadersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdSeasonLeaders>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLeagueIdSeasonLeadersQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Season history for a league (World Series results + per-season links).
 */
export const getLeagueIdSeasons = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<LeagueSeasonRow[]>(
      {url: `/League/${id}/Seasons`, method: 'GET', signal
    },
      );
    }




export const getGetLeagueIdSeasonsQueryKey = (id: number,) => {
    return [
    `/League/${id}/Seasons`
    ] as const;
    }


export const getGetLeagueIdSeasonsQueryOptions = <TData = Awaited<ReturnType<typeof getLeagueIdSeasons>>, TError = ProblemDetails>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdSeasons>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeagueIdSeasonsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeagueIdSeasons>>> = ({ signal }) => getLeagueIdSeasons(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdSeasons>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLeagueIdSeasonsQueryResult = NonNullable<Awaited<ReturnType<typeof getLeagueIdSeasons>>>
export type GetLeagueIdSeasonsQueryError = ProblemDetails


export function useGetLeagueIdSeasons<TData = Awaited<ReturnType<typeof getLeagueIdSeasons>>, TError = ProblemDetails>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdSeasons>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdSeasons>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdSeasons>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdSeasons<TData = Awaited<ReturnType<typeof getLeagueIdSeasons>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdSeasons>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdSeasons>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdSeasons>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdSeasons<TData = Awaited<ReturnType<typeof getLeagueIdSeasons>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdSeasons>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Season history for a league (World Series results + per-season links).
 */

export function useGetLeagueIdSeasons<TData = Awaited<ReturnType<typeof getLeagueIdSeasons>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdSeasons>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLeagueIdSeasonsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Every editable league setting plus the form context flags. Commissioner/admin only.
404 if the league is missing or has no settings; 403 if the caller is not a manager.
 */
export const getLeagueIdSettings = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<LeagueSettingsResponse>(
      {url: `/League/${id}/Settings`, method: 'GET', signal
    },
      );
    }




export const getGetLeagueIdSettingsQueryKey = (id: number,) => {
    return [
    `/League/${id}/Settings`
    ] as const;
    }


export const getGetLeagueIdSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getLeagueIdSettings>>, TError = ProblemDetails>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdSettings>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeagueIdSettingsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeagueIdSettings>>> = ({ signal }) => getLeagueIdSettings(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLeagueIdSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getLeagueIdSettings>>>
export type GetLeagueIdSettingsQueryError = ProblemDetails


export function useGetLeagueIdSettings<TData = Awaited<ReturnType<typeof getLeagueIdSettings>>, TError = ProblemDetails>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdSettings>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdSettings>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdSettings<TData = Awaited<ReturnType<typeof getLeagueIdSettings>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdSettings>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdSettings>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdSettings<TData = Awaited<ReturnType<typeof getLeagueIdSettings>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdSettings>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Every editable league setting plus the form context flags. Commissioner/admin only.
404 if the league is missing or has no settings; 403 if the caller is not a manager.
 */

export function useGetLeagueIdSettings<TData = Awaited<ReturnType<typeof getLeagueIdSettings>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdSettings>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLeagueIdSettingsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Updates the league settings (commissioner/admin only). Server-side validation
is the full port of the legacy settings form. 400 on any invalid field.
 */
export const putLeagueIdSettings = (
    id: number,
    updateLeagueSettingsRequest?: UpdateLeagueSettingsRequest,
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/League/${id}/Settings`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateLeagueSettingsRequest, signal
    },
      );
    }




export const getPutLeagueIdSettingsMutationKey = () => ['putLeagueIdSettings'] as const;

export const getPutLeagueIdSettingsMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putLeagueIdSettings>>, TError,PutLeagueIdSettingsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putLeagueIdSettings>>, TError,PutLeagueIdSettingsMutationVariables, TContext> => {

const mutationKey = getPutLeagueIdSettingsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putLeagueIdSettings>>, PutLeagueIdSettingsMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  putLeagueIdSettings(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutLeagueIdSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof putLeagueIdSettings>>>
    export type PutLeagueIdSettingsMutationBody = UpdateLeagueSettingsRequest | undefined
    export type PutLeagueIdSettingsMutationError = ErrorResult | ProblemDetails
    export type PutLeagueIdSettingsMutationVariables = {id: number;data?: UpdateLeagueSettingsRequest}

    /**
 * @summary Updates the league settings (commissioner/admin only). Server-side validation
is the full port of the legacy settings form. 400 on any invalid field.
 */
export const usePutLeagueIdSettings = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putLeagueIdSettings>>, TError,PutLeagueIdSettingsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putLeagueIdSettings>>,
        TError,
        PutLeagueIdSettingsMutationVariables,
        TContext
      > => {
      return useMutation(getPutLeagueIdSettingsMutationOptions(options), queryClient);
    }
    /**
 * @summary Stadium dimensions/surface for every team in a league.
 */
export const getLeagueIdStadiums = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<LeagueStadiumRow[]>(
      {url: `/League/${id}/Stadiums`, method: 'GET', signal
    },
      );
    }




export const getGetLeagueIdStadiumsQueryKey = (id: number,) => {
    return [
    `/League/${id}/Stadiums`
    ] as const;
    }


export const getGetLeagueIdStadiumsQueryOptions = <TData = Awaited<ReturnType<typeof getLeagueIdStadiums>>, TError = ProblemDetails>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdStadiums>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeagueIdStadiumsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeagueIdStadiums>>> = ({ signal }) => getLeagueIdStadiums(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdStadiums>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLeagueIdStadiumsQueryResult = NonNullable<Awaited<ReturnType<typeof getLeagueIdStadiums>>>
export type GetLeagueIdStadiumsQueryError = ProblemDetails


export function useGetLeagueIdStadiums<TData = Awaited<ReturnType<typeof getLeagueIdStadiums>>, TError = ProblemDetails>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdStadiums>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdStadiums>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdStadiums>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdStadiums<TData = Awaited<ReturnType<typeof getLeagueIdStadiums>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdStadiums>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdStadiums>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdStadiums>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdStadiums<TData = Awaited<ReturnType<typeof getLeagueIdStadiums>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdStadiums>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Stadium dimensions/surface for every team in a league.
 */

export function useGetLeagueIdStadiums<TData = Awaited<ReturnType<typeof getLeagueIdStadiums>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdStadiums>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLeagueIdStadiumsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary League standings for a season (defaults to the current season).
 */
export const getLeagueIdStandings = (
    id: number,
    params?: GetLeagueIdStandingsParams,
 signal?: AbortSignal
) => {


      return fetcher<LeagueStandingsResponse>(
      {url: `/League/${id}/Standings`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetLeagueIdStandingsQueryKey = (id: number,
    params?: GetLeagueIdStandingsParams,) => {
    return [
    `/League/${id}/Standings`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLeagueIdStandingsQueryOptions = <TData = Awaited<ReturnType<typeof getLeagueIdStandings>>, TError = ProblemDetails>(id: number,
    params?: GetLeagueIdStandingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdStandings>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeagueIdStandingsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeagueIdStandings>>> = ({ signal }) => getLeagueIdStandings(id,params, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdStandings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLeagueIdStandingsQueryResult = NonNullable<Awaited<ReturnType<typeof getLeagueIdStandings>>>
export type GetLeagueIdStandingsQueryError = ProblemDetails


export function useGetLeagueIdStandings<TData = Awaited<ReturnType<typeof getLeagueIdStandings>>, TError = ProblemDetails>(
 id: number,
    params: undefined |  GetLeagueIdStandingsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdStandings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdStandings>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdStandings>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdStandings<TData = Awaited<ReturnType<typeof getLeagueIdStandings>>, TError = ProblemDetails>(
 id: number,
    params?: GetLeagueIdStandingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdStandings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdStandings>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdStandings>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdStandings<TData = Awaited<ReturnType<typeof getLeagueIdStandings>>, TError = ProblemDetails>(
 id: number,
    params?: GetLeagueIdStandingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdStandings>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary League standings for a season (defaults to the current season).
 */

export function useGetLeagueIdStandings<TData = Awaited<ReturnType<typeof getLeagueIdStandings>>, TError = ProblemDetails>(
 id: number,
    params?: GetLeagueIdStandingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdStandings>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLeagueIdStandingsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary League-wide player batting/pitching/fielding stats. All 5 filter params required (no magic defaults). 400 if missing; 404 if the league is missing.
 */
export const getLeagueIdStats = (
    id: number,
    params: GetLeagueIdStatsParams,
 signal?: AbortSignal
) => {


      return fetcher<LeagueStatsResponse>(
      {url: `/League/${id}/Stats`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetLeagueIdStatsQueryKey = (id: number,
    params?: GetLeagueIdStatsParams,) => {
    return [
    `/League/${id}/Stats`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLeagueIdStatsQueryOptions = <TData = Awaited<ReturnType<typeof getLeagueIdStats>>, TError = ProblemDetails>(id: number,
    params: GetLeagueIdStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdStats>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeagueIdStatsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeagueIdStats>>> = ({ signal }) => getLeagueIdStats(id,params, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdStats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLeagueIdStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getLeagueIdStats>>>
export type GetLeagueIdStatsQueryError = ProblemDetails


export function useGetLeagueIdStats<TData = Awaited<ReturnType<typeof getLeagueIdStats>>, TError = ProblemDetails>(
 id: number,
    params: GetLeagueIdStatsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdStats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdStats>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdStats<TData = Awaited<ReturnType<typeof getLeagueIdStats>>, TError = ProblemDetails>(
 id: number,
    params: GetLeagueIdStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdStats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdStats>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdStats<TData = Awaited<ReturnType<typeof getLeagueIdStats>>, TError = ProblemDetails>(
 id: number,
    params: GetLeagueIdStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdStats>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary League-wide player batting/pitching/fielding stats. All 5 filter params required (no magic defaults). 400 if missing; 404 if the league is missing.
 */

export function useGetLeagueIdStats<TData = Awaited<ReturnType<typeof getLeagueIdStats>>, TError = ProblemDetails>(
 id: number,
    params: GetLeagueIdStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdStats>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLeagueIdStatsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary The league's conferences and divisions, for the structure editor.
Commissioner/admin only. 404 if the league is missing or has no
settings; 403 if the caller is not a commissioner or admin.
 */
export const getLeagueIdStructure = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<LeagueStructureResponse>(
      {url: `/League/${id}/Structure`, method: 'GET', signal
    },
      );
    }




export const getGetLeagueIdStructureQueryKey = (id: number,) => {
    return [
    `/League/${id}/Structure`
    ] as const;
    }


export const getGetLeagueIdStructureQueryOptions = <TData = Awaited<ReturnType<typeof getLeagueIdStructure>>, TError = ProblemDetails>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdStructure>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeagueIdStructureQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeagueIdStructure>>> = ({ signal }) => getLeagueIdStructure(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdStructure>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLeagueIdStructureQueryResult = NonNullable<Awaited<ReturnType<typeof getLeagueIdStructure>>>
export type GetLeagueIdStructureQueryError = ProblemDetails


export function useGetLeagueIdStructure<TData = Awaited<ReturnType<typeof getLeagueIdStructure>>, TError = ProblemDetails>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdStructure>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdStructure>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdStructure>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdStructure<TData = Awaited<ReturnType<typeof getLeagueIdStructure>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdStructure>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdStructure>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdStructure>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdStructure<TData = Awaited<ReturnType<typeof getLeagueIdStructure>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdStructure>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The league's conferences and divisions, for the structure editor.
Commissioner/admin only. 404 if the league is missing or has no
settings; 403 if the caller is not a commissioner or admin.
 */

export function useGetLeagueIdStructure<TData = Awaited<ReturnType<typeof getLeagueIdStructure>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdStructure>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLeagueIdStructureQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Renames the league's conferences/divisions. Commissioner/admin only.
400 on an invalid name or an id that does not belong to the league.
 */
export const putLeagueIdStructure = (
    id: number,
    updateLeagueStructureRequest?: UpdateLeagueStructureRequest,
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/League/${id}/Structure`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateLeagueStructureRequest, signal
    },
      );
    }




export const getPutLeagueIdStructureMutationKey = () => ['putLeagueIdStructure'] as const;

export const getPutLeagueIdStructureMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putLeagueIdStructure>>, TError,PutLeagueIdStructureMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putLeagueIdStructure>>, TError,PutLeagueIdStructureMutationVariables, TContext> => {

const mutationKey = getPutLeagueIdStructureMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putLeagueIdStructure>>, PutLeagueIdStructureMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  putLeagueIdStructure(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutLeagueIdStructureMutationResult = NonNullable<Awaited<ReturnType<typeof putLeagueIdStructure>>>
    export type PutLeagueIdStructureMutationBody = UpdateLeagueStructureRequest | undefined
    export type PutLeagueIdStructureMutationError = ErrorResult | ProblemDetails
    export type PutLeagueIdStructureMutationVariables = {id: number;data?: UpdateLeagueStructureRequest}

    /**
 * @summary Renames the league's conferences/divisions. Commissioner/admin only.
400 on an invalid name or an id that does not belong to the league.
 */
export const usePutLeagueIdStructure = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putLeagueIdStructure>>, TError,PutLeagueIdStructureMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putLeagueIdStructure>>,
        TError,
        PutLeagueIdStructureMutationVariables,
        TContext
      > => {
      return useMutation(getPutLeagueIdStructureMutationOptions(options), queryClient);
    }
    /**
 * @summary Every team in the league with its current owner. Commissioner/admin only.
404 if the league is missing or has no settings; 403 if the caller is not a commissioner or admin.
 */
export const getLeagueIdTeamOwners = (
    id: number,
 signal?: AbortSignal
) => {


      return fetcher<LeagueTeamOwnersResponse>(
      {url: `/League/${id}/TeamOwners`, method: 'GET', signal
    },
      );
    }




export const getGetLeagueIdTeamOwnersQueryKey = (id: number,) => {
    return [
    `/League/${id}/TeamOwners`
    ] as const;
    }


export const getGetLeagueIdTeamOwnersQueryOptions = <TData = Awaited<ReturnType<typeof getLeagueIdTeamOwners>>, TError = ProblemDetails>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdTeamOwners>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeagueIdTeamOwnersQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeagueIdTeamOwners>>> = ({ signal }) => getLeagueIdTeamOwners(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdTeamOwners>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLeagueIdTeamOwnersQueryResult = NonNullable<Awaited<ReturnType<typeof getLeagueIdTeamOwners>>>
export type GetLeagueIdTeamOwnersQueryError = ProblemDetails


export function useGetLeagueIdTeamOwners<TData = Awaited<ReturnType<typeof getLeagueIdTeamOwners>>, TError = ProblemDetails>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdTeamOwners>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdTeamOwners>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdTeamOwners>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdTeamOwners<TData = Awaited<ReturnType<typeof getLeagueIdTeamOwners>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdTeamOwners>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdTeamOwners>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdTeamOwners>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdTeamOwners<TData = Awaited<ReturnType<typeof getLeagueIdTeamOwners>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdTeamOwners>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Every team in the league with its current owner. Commissioner/admin only.
404 if the league is missing or has no settings; 403 if the caller is not a commissioner or admin.
 */

export function useGetLeagueIdTeamOwners<TData = Awaited<ReturnType<typeof getLeagueIdTeamOwners>>, TError = ProblemDetails>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdTeamOwners>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLeagueIdTeamOwnersQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Reassigns a team's owner (commissioner/admin only). A blank username sets
the team unowned. 400 when the team is not in the league or the username
matches no user.
 */
export const putLeagueIdTeamTeamIdOwner = (
    id: number,
    teamId: number,
    updateTeamOwnerRequest?: UpdateTeamOwnerRequest,
 signal?: AbortSignal
) => {


      return fetcher<void>(
      {url: `/League/${id}/Team/${teamId}/Owner`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateTeamOwnerRequest, signal
    },
      );
    }




export const getPutLeagueIdTeamTeamIdOwnerMutationKey = () => ['putLeagueIdTeamTeamIdOwner'] as const;

export const getPutLeagueIdTeamTeamIdOwnerMutationOptions = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putLeagueIdTeamTeamIdOwner>>, TError,PutLeagueIdTeamTeamIdOwnerMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putLeagueIdTeamTeamIdOwner>>, TError,PutLeagueIdTeamTeamIdOwnerMutationVariables, TContext> => {

const mutationKey = getPutLeagueIdTeamTeamIdOwnerMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putLeagueIdTeamTeamIdOwner>>, PutLeagueIdTeamTeamIdOwnerMutationVariables> = (props) => {
          const {id,teamId,data} = props ?? {};

          return  putLeagueIdTeamTeamIdOwner(id,teamId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutLeagueIdTeamTeamIdOwnerMutationResult = NonNullable<Awaited<ReturnType<typeof putLeagueIdTeamTeamIdOwner>>>
    export type PutLeagueIdTeamTeamIdOwnerMutationBody = UpdateTeamOwnerRequest | undefined
    export type PutLeagueIdTeamTeamIdOwnerMutationError = ErrorResult | ProblemDetails
    export type PutLeagueIdTeamTeamIdOwnerMutationVariables = {id: number;teamId: number;data?: UpdateTeamOwnerRequest}

    /**
 * @summary Reassigns a team's owner (commissioner/admin only). A blank username sets
the team unowned. 400 when the team is not in the league or the username
matches no user.
 */
export const usePutLeagueIdTeamTeamIdOwner = <TError = ErrorResult | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putLeagueIdTeamTeamIdOwner>>, TError,PutLeagueIdTeamTeamIdOwnerMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putLeagueIdTeamTeamIdOwner>>,
        TError,
        PutLeagueIdTeamTeamIdOwnerMutationVariables,
        TContext
      > => {
      return useMutation(getPutLeagueIdTeamTeamIdOwnerMutationOptions(options), queryClient);
    }
    /**
 * @summary League-wide team batting/pitching/fielding stats. type+show both required. 400 if missing; 404 if the league is missing.
 */
export const getLeagueIdTeamStats = (
    id: number,
    params: GetLeagueIdTeamStatsParams,
 signal?: AbortSignal
) => {


      return fetcher<LeagueTeamStatsResponse>(
      {url: `/League/${id}/TeamStats`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetLeagueIdTeamStatsQueryKey = (id: number,
    params?: GetLeagueIdTeamStatsParams,) => {
    return [
    `/League/${id}/TeamStats`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLeagueIdTeamStatsQueryOptions = <TData = Awaited<ReturnType<typeof getLeagueIdTeamStats>>, TError = ProblemDetails>(id: number,
    params: GetLeagueIdTeamStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdTeamStats>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeagueIdTeamStatsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeagueIdTeamStats>>> = ({ signal }) => getLeagueIdTeamStats(id,params, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdTeamStats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLeagueIdTeamStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getLeagueIdTeamStats>>>
export type GetLeagueIdTeamStatsQueryError = ProblemDetails


export function useGetLeagueIdTeamStats<TData = Awaited<ReturnType<typeof getLeagueIdTeamStats>>, TError = ProblemDetails>(
 id: number,
    params: GetLeagueIdTeamStatsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdTeamStats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdTeamStats>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdTeamStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdTeamStats<TData = Awaited<ReturnType<typeof getLeagueIdTeamStats>>, TError = ProblemDetails>(
 id: number,
    params: GetLeagueIdTeamStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdTeamStats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdTeamStats>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdTeamStats>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdTeamStats<TData = Awaited<ReturnType<typeof getLeagueIdTeamStats>>, TError = ProblemDetails>(
 id: number,
    params: GetLeagueIdTeamStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdTeamStats>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary League-wide team batting/pitching/fielding stats. type+show both required. 400 if missing; 404 if the league is missing.
 */

export function useGetLeagueIdTeamStats<TData = Awaited<ReturnType<typeof getLeagueIdTeamStats>>, TError = ProblemDetails>(
 id: number,
    params: GetLeagueIdTeamStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdTeamStats>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLeagueIdTeamStatsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Read-only trades view for a season (history always; proposals + trade block current-season only). 404 if the league has no trades.
 */
export const getLeagueIdTrades = (
    id: number,
    params?: GetLeagueIdTradesParams,
 signal?: AbortSignal
) => {


      return fetcher<LeagueTradesResponse>(
      {url: `/League/${id}/Trades`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetLeagueIdTradesQueryKey = (id: number,
    params?: GetLeagueIdTradesParams,) => {
    return [
    `/League/${id}/Trades`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLeagueIdTradesQueryOptions = <TData = Awaited<ReturnType<typeof getLeagueIdTrades>>, TError = ProblemDetails>(id: number,
    params?: GetLeagueIdTradesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdTrades>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeagueIdTradesQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeagueIdTrades>>> = ({ signal }) => getLeagueIdTrades(id,params, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdTrades>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLeagueIdTradesQueryResult = NonNullable<Awaited<ReturnType<typeof getLeagueIdTrades>>>
export type GetLeagueIdTradesQueryError = ProblemDetails


export function useGetLeagueIdTrades<TData = Awaited<ReturnType<typeof getLeagueIdTrades>>, TError = ProblemDetails>(
 id: number,
    params: undefined |  GetLeagueIdTradesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdTrades>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdTrades>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdTrades>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdTrades<TData = Awaited<ReturnType<typeof getLeagueIdTrades>>, TError = ProblemDetails>(
 id: number,
    params?: GetLeagueIdTradesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdTrades>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdTrades>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdTrades>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdTrades<TData = Awaited<ReturnType<typeof getLeagueIdTrades>>, TError = ProblemDetails>(
 id: number,
    params?: GetLeagueIdTradesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdTrades>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read-only trades view for a season (history always; proposals + trade block current-season only). 404 if the league has no trades.
 */

export function useGetLeagueIdTrades<TData = Awaited<ReturnType<typeof getLeagueIdTrades>>, TError = ProblemDetails>(
 id: number,
    params?: GetLeagueIdTradesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdTrades>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLeagueIdTradesQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Read-only detail for a single trade, scoped to the league rather than to one
participating team. This is the neutral viewing surface used from non-team
contexts (the league trades page and the player pages); acting on a trade
lives on /Team/League/{teamId}/Trade/{tradeId}, which is unchanged.
404 if the league has no trades, the trade does not exist, or the trade
does not belong to this league.
 */
export const getLeagueIdTradeTradeId = (
    id: number,
    tradeId: number,
 signal?: AbortSignal
) => {


      return fetcher<LeagueTradeDetailResponse>(
      {url: `/League/${id}/Trade/${tradeId}`, method: 'GET', signal
    },
      );
    }




export const getGetLeagueIdTradeTradeIdQueryKey = (id: number,
    tradeId: number,) => {
    return [
    `/League/${id}/Trade/${tradeId}`
    ] as const;
    }


export const getGetLeagueIdTradeTradeIdQueryOptions = <TData = Awaited<ReturnType<typeof getLeagueIdTradeTradeId>>, TError = ProblemDetails>(id: number,
    tradeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdTradeTradeId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeagueIdTradeTradeIdQueryKey(id,tradeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeagueIdTradeTradeId>>> = ({ signal }) => getLeagueIdTradeTradeId(id,tradeId, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && tradeId !== null && tradeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdTradeTradeId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLeagueIdTradeTradeIdQueryResult = NonNullable<Awaited<ReturnType<typeof getLeagueIdTradeTradeId>>>
export type GetLeagueIdTradeTradeIdQueryError = ProblemDetails


export function useGetLeagueIdTradeTradeId<TData = Awaited<ReturnType<typeof getLeagueIdTradeTradeId>>, TError = ProblemDetails>(
 id: number,
    tradeId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdTradeTradeId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdTradeTradeId>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdTradeTradeId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdTradeTradeId<TData = Awaited<ReturnType<typeof getLeagueIdTradeTradeId>>, TError = ProblemDetails>(
 id: number,
    tradeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdTradeTradeId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdTradeTradeId>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdTradeTradeId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdTradeTradeId<TData = Awaited<ReturnType<typeof getLeagueIdTradeTradeId>>, TError = ProblemDetails>(
 id: number,
    tradeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdTradeTradeId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read-only detail for a single trade, scoped to the league rather than to one
participating team. This is the neutral viewing surface used from non-team
contexts (the league trades page and the player pages); acting on a trade
lives on /Team/League/{teamId}/Trade/{tradeId}, which is unchanged.
404 if the league has no trades, the trade does not exist, or the trade
does not belong to this league.
 */

export function useGetLeagueIdTradeTradeId<TData = Awaited<ReturnType<typeof getLeagueIdTradeTradeId>>, TError = ProblemDetails>(
 id: number,
    tradeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdTradeTradeId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLeagueIdTradeTradeIdQueryOptions(id,tradeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary League transaction log for a season (defaults to the current season). 404 if the league has no transactions.
 */
export const getLeagueIdTransactions = (
    id: number,
    params?: GetLeagueIdTransactionsParams,
 signal?: AbortSignal
) => {


      return fetcher<LeagueTransactionsResponse>(
      {url: `/League/${id}/Transactions`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetLeagueIdTransactionsQueryKey = (id: number,
    params?: GetLeagueIdTransactionsParams,) => {
    return [
    `/League/${id}/Transactions`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLeagueIdTransactionsQueryOptions = <TData = Awaited<ReturnType<typeof getLeagueIdTransactions>>, TError = ProblemDetails>(id: number,
    params?: GetLeagueIdTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdTransactions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeagueIdTransactionsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeagueIdTransactions>>> = ({ signal }) => getLeagueIdTransactions(id,params, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdTransactions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLeagueIdTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof getLeagueIdTransactions>>>
export type GetLeagueIdTransactionsQueryError = ProblemDetails


export function useGetLeagueIdTransactions<TData = Awaited<ReturnType<typeof getLeagueIdTransactions>>, TError = ProblemDetails>(
 id: number,
    params: undefined |  GetLeagueIdTransactionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdTransactions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdTransactions>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdTransactions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdTransactions<TData = Awaited<ReturnType<typeof getLeagueIdTransactions>>, TError = ProblemDetails>(
 id: number,
    params?: GetLeagueIdTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdTransactions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdTransactions>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdTransactions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdTransactions<TData = Awaited<ReturnType<typeof getLeagueIdTransactions>>, TError = ProblemDetails>(
 id: number,
    params?: GetLeagueIdTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdTransactions>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary League transaction log for a season (defaults to the current season). 404 if the league has no transactions.
 */

export function useGetLeagueIdTransactions<TData = Awaited<ReturnType<typeof getLeagueIdTransactions>>, TError = ProblemDetails>(
 id: number,
    params?: GetLeagueIdTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdTransactions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLeagueIdTransactionsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary League landing page (name, settings, rules, draft snapshot, team grid).
Requires an authenticated user — the API is deny-by-default (global
FallbackPolicy.RequireAuthenticatedUser in Program.cs) and this endpoint
carries no [AllowAnonymous]. User-aware: canRecruit / commish-tools resolve
from the caller's identity (CurrentUserPrincipal). 404 if the league is
missing or the season is out of range (parity with legacy league/view.asp).
 */
export const getLeagueIdView = (
    id: number,
    params?: GetLeagueIdViewParams,
 signal?: AbortSignal
) => {


      return fetcher<LeagueViewResponse>(
      {url: `/League/${id}/View`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetLeagueIdViewQueryKey = (id: number,
    params?: GetLeagueIdViewParams,) => {
    return [
    `/League/${id}/View`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLeagueIdViewQueryOptions = <TData = Awaited<ReturnType<typeof getLeagueIdView>>, TError = ProblemDetails>(id: number,
    params?: GetLeagueIdViewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdView>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeagueIdViewQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeagueIdView>>> = ({ signal }) => getLeagueIdView(id,params, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdView>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLeagueIdViewQueryResult = NonNullable<Awaited<ReturnType<typeof getLeagueIdView>>>
export type GetLeagueIdViewQueryError = ProblemDetails


export function useGetLeagueIdView<TData = Awaited<ReturnType<typeof getLeagueIdView>>, TError = ProblemDetails>(
 id: number,
    params: undefined |  GetLeagueIdViewParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdView>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdView>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdView>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdView<TData = Awaited<ReturnType<typeof getLeagueIdView>>, TError = ProblemDetails>(
 id: number,
    params?: GetLeagueIdViewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdView>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLeagueIdView>>,
          TError,
          Awaited<ReturnType<typeof getLeagueIdView>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLeagueIdView<TData = Awaited<ReturnType<typeof getLeagueIdView>>, TError = ProblemDetails>(
 id: number,
    params?: GetLeagueIdViewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdView>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary League landing page (name, settings, rules, draft snapshot, team grid).
Requires an authenticated user — the API is deny-by-default (global
FallbackPolicy.RequireAuthenticatedUser in Program.cs) and this endpoint
carries no [AllowAnonymous]. User-aware: canRecruit / commish-tools resolve
from the caller's identity (CurrentUserPrincipal). 404 if the league is
missing or the season is out of range (parity with legacy league/view.asp).
 */

export function useGetLeagueIdView<TData = Awaited<ReturnType<typeof getLeagueIdView>>, TError = ProblemDetails>(
 id: number,
    params?: GetLeagueIdViewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLeagueIdView>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLeagueIdViewQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






